<template>
  <el-dialog
    title="仪器串"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form
      ref="form"
      size="small"
      label-width="100px"
      :rules="rules"
      :model="model"
    >
      <el-form-item label="仪器串名称" prop="name">
        <el-input v-model.trim="model.name"></el-input>
        <div
          class="font-12 text-info"
          style="line-height: 2em"
          v-if="model.copy_add"
        >
          复制添加时请修改名称
        </div>
      </el-form-item>
      <el-form-item label="包含仪器" prop="product_ids">
        <ProductMultipleSelect
          v-if="visible"
          v-model="model.product_ids"
          :wellId="model.drill_well_id"
        ></ProductMultipleSelect>
      </el-form-item>
      <el-form-item label="趟钻数" prop="usage">
        <el-select v-model="model.usage" style="width: 100%">
          <el-option v-for="i in 100" :key="i" :value="i" :label="`第${i}趟`"
            >第{{ i }}趟</el-option
          >
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="工作时长" prop="used_hour">
        <el-input-number v-model="model.used_hour"></el-input-number>
      </el-form-item>
      <el-form-item label="起钻原因" prop="up_reason">
        <el-input
          v-model="model.up_reason"
          type="textarea"
          :autosize="{ minRows: 2 }"
        ></el-input>
      </el-form-item>
      <el-form-item label="故障描述" prop="malfunction">
        <el-input
          v-model="model.malfunction"
          type="textarea"
          :autosize="{ minRows: 2 }"
        ></el-input>
        <div class="font-12" style="line-height: 1.5em; margin-top: 5px">
          注：如果无故障请输入
          <span class="pointer" @click="model.malfunction = '/'">
            <span class="text-info">"/"</span>（或点此输入）。</span
          >
        </div>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productGroupNew, productGroupUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        name: [{ required: true, message: '请填写名称', trigger: 'change' }],
        usage: [
          { required: true, message: '请选择趟钻数', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '趟钻不能为0',
            trigger: 'change',
          },
        ],
        used_hour: [
          { required: true, message: '使用时长不能为空', trigger: 'change' },
          {
            type: 'number',
            min: 1,
            max: 100000,
            message: '使用时长不能为0',
            trigger: 'blur',
          },
        ],
        up_reason: [{ required: true, message: '请填写', trigger: 'change' }],
        malfunction: [{ required: true, message: '请填写', trigger: 'change' }],
        product_ids: [
          { required: true, message: '请选择仪器', trigger: 'change' },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          if (this.model.id > 0) {
            let res = await productGroupUpdate(this.model)
            if (res.status == 0) {
              this.$emit('updated', res.data)
              this.visible = false
            }
          } else {
            let res = await productGroupNew(this.model)
            if (res.status == 0) {
              this.$emit('created', res.data)
              this.visible = false
            }
          }
          this.submiting = false
        }
      })
    },
  },
}
</script>
